import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaUserCircle, FaTimes } from "react-icons/fa";
import SidebarComponent from "../../components/SideBar";
import { BASE_URL, HEADERS } from "../../utils/constant";
import Profile from "../../components/Modals/ProfileModel";
import axios from "axios";
import { toast } from "react-toastify";
import Tickets from "../Tickets";
import MainDashboard from "../MainDashboard";
import Services from "../Services";
import Fsr from "../FSR";
import Technician from "../Technicians";
import Attendance from "../Attendenece";
import Expenditure from "../Expenditure";
import CustomersList from "../CustomerList";
import TrackAll from "../TrackAll";
import LeadList from "../LeadList";
import Amc from "../Amc";
import CheckInOut from "../CheckInOut";
import TechExpenditure from "../TechExpenditure";
import Admin from "../Admin";
import Agent from "../Agent";
import SuperUser from "../SuperUser";
import ServiceRequest from "../ServiceRequest";
import HolidayCalendar from "../HolidaysCalender";
import LeaveReport from "../LeaveReport";
import UserLeaveData from "../EmployesLeaves";
import Sales from "../Sales";
import { useCommonContext } from "../../utils/context";
import { Rating } from "react-simple-star-rating";
import MyLeaveReport from "../SuperuserLeaves";
import SubCustomerList from "../SubcustomerList";
import Subscription from "../Subscription";
import UserDataDeletionForm from "../../components/UserDataDeletionForm";
import Support from "../HelpAndSupport";
import Inventory from "../Inventory";
import UserLogsList from "../UserLogs";
import InvoiceList from "../Invoices";
// import PermissionModal from "../AccessPermission";

function Dashboard() {
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("role");
  const navigate = useNavigate();
  const location = useLocation();
  const { toggled, setToggled } = useCommonContext();
  const [showCloseIcon, setShowCloseIcon] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const { subscription } = useCommonContext();

  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState([]);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const { fetchUser, user, isloading } = useCommonContext();
  const splitPath = location?.pathname?.split("/");
  const subscriptionStatus = localStorage.getItem("subscription_status");

  const image =
    localStorage.getItem("profile_image") !== "null"
      ? localStorage.getItem("profile_image")
      : null;

  useEffect(() => {
    setShowCloseIcon(toggled);
  }, [toggled]);

  useEffect(() => {
    if (
      subscriptionStatus === "expired" &&
      location.pathname !== "/dashboard/subscription"
    ) {
      navigate("/dashboard/subscription", { replace: true });
    }
  }, [subscriptionStatus, location.pathname, navigate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".profile-menu")) {
        setIsProfileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const calculateDaysLeft = (endDate) => {
    if (!endDate) return 0;
    const today = new Date();
    const end = new Date(endDate);
    const diff = end - today;
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
  };

  const renderStep = (key) => {
    if (subscriptionStatus === "expired") {
      return <Subscription />;
    }

    switch (key) {
      case "/dashboard":
        return <MainDashboard />;

      case "/dashboard/sales":
        return <Sales />;
      case "/dashboard/support":
        return <Support />;
      case "/dashboard/invoices":
        return <InvoiceList />;
      case "/dashboard/logs":
        return <UserLogsList />;
      case "/dashboard/subscription":
        return <Subscription />;
      case "/dashboard/holidays-calendar":
        return <HolidayCalendar />;
      case "/dashboard/leaves-report":
        return <LeaveReport />;
      case "/dashboard/tickets":
        return <Tickets />;
      case "/dashboard/subcustomer":
        return <SubCustomerList />;
      case "/dashboard/admin":
        return <Admin />;

      case "/dashboard/userleavedata":
        return <UserLeaveData />;
      case "/dashboard/agent":
        return <Agent />;
      case "/dashboard/superuser":
        return <SuperUser />;

      case "/dashboard/customer-list":
        return <CustomersList />;

      case "/dashboard/lead-list":
        return <LeadList />;
      case "/dashboard/fsr":
        return <Fsr />;
      case "/dashboard/amc":
        return <Amc />;
      case "/dashboard/technician":
        return <Technician />;

      case "/dashboard/attendance":
        return <Attendance />;
      case "/dashboard/my-attendence":
        return <CheckInOut />;
      case "/dashboard/expenditure":
        return <Expenditure />;
      case "/dashboard/servicerequests":
        return <ServiceRequest />;

      case "/dashboard/inventory":
        return <Inventory />;

      case "/dashboard/track-all":
        return <TrackAll />;
      case "/dashboard/services":
        return <Services />;
      case "/dashboard/my-leave":
        return <MyLeaveReport />;

      case "/dashboard/Expense":
        return <TechExpenditure />;

      // case "/dashboard/access-permission":
      // return <PermissionModal />;

      default:
        return null;
    }
  };

  const handleLogout = () => {
    navigate("/");
    localStorage.clear();
  };

  const handleProfile = () => {
    setShowProfileModal(true);
  };

  const handleUpgradePlans = () => {
    navigate("/dashboard/subscription");
  };

  useEffect(() => {
    fetchRating();
  }, []);

  const fetchRating = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/tickets/count_rated_customers/`,
        {
          headers: HEADERS,
        },
      );
      if (response && response.data) {
        setRating(response.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch subscription data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      id="wrapper"
      className="d-flex flex-column min-vh-100"
      style={{ overflowX: "hidden" }}
    >
      <div
        className="d-flex flex-grow-1 w-100"
        style={{
          pointerEvents: subscriptionStatus === "expired" ? "none" : "auto",
          opacity: subscriptionStatus === "expired" ? 0.5 : 1,
        }}
      >
        {toggled && (
          <SidebarComponent
            toggled={toggled}
            setToggled={setToggled}
            customerId={location?.pathname?.includes("details")}
          />
        )}

        <div
          className={`maincontentdiv flex-grow-1 ${toggled ? "with-sidebar" : ""}`}
          style={{ overflowX: "hidden" }}
        >
          <header className="header px-3 py-2 d-flex justify-content-between align-items-center sticky-top">
            <div>
              {showCloseIcon ? (
                <FaTimes
                  className="toggleBar"
                  style={{ color: "#000", cursor: "pointer" }}
                  onClick={() => setToggled(!toggled)}
                  size={25}
                />
              ) : (
                <FaBars
                  className="toggleBar"
                  style={{ color: "#000", cursor: "pointer" }}
                  onClick={() => setToggled(!toggled)}
                  size={25}
                />
              )}
            </div>

            <div className="d-flex align-items-center gap-3 flex-wrap justify-content-end">
              {subscription && (
                <div
                  className="d-flex align-items-center px-3 py-1 rounded-pill"
                  style={{
                    fontSize: "13px",
                    fontWeight: 500,
                    backgroundColor:
                      subscription.status === "trial"
                        ? "#FFF3CD"
                        : subscription.status === "active"
                          ? "#E6F4EA"
                          : "#F8D7DA",
                    color:
                      subscription.status === "trial"
                        ? "#856404"
                        : subscription.status === "active"
                          ? "#1E7E34"
                          : "#721C24",
                  }}
                >
                  {subscription.status === "trial" && (
                    <>
                      Trial • {calculateDaysLeft(subscription.trial_end_date)}{" "}
                      days left
                    </>
                  )}

                  {subscription.status === "active" && (
                    <>{subscription.plan || "Active Plan"} • Active</>
                  )}

                  {subscription.status === "expired" && <>Expired • Upgrade</>}
                </div>
              )}

              {rating && (
                <div className="d-flex align-items-center customer-rating gap-2">
                  <span className="fw-semibold mb-0">Rating:</span>
                  <Rating
                    initialValue={rating?.average_rating}
                    readonly
                    size={20}
                    fillColor="#FFD700"
                    emptyColor="#E0E0E0"
                  />
                </div>
              )}

              <div
                className="position-relative profile-menu"
                onClick={() => setIsProfileOpen(!isProfileOpen)}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="profile-img d-flex align-items-center justify-content-center"
                  style={{
                    width: "45px",
                    height: "45px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    backgroundColor: "#f1f3f5",
                  }}
                >
                  {image || user?.profile_image ? (
                    <img
                      src={image || user?.profile_image}
                      alt="user"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <FaUserCircle
                      style={{
                        width: "100%",
                        height: "100%",
                        color: "#adb5bd",
                      }}
                    />
                  )}
                </div>

                {isProfileOpen && (
                  <div
                    className="menu-list profile-dropdown bg-white shadow p-2 rounded position-absolute end-0 mt-2"
                    style={{ zIndex: 1000, minWidth: "180px" }}
                  >
                    <ul className="list-unstyled mb-0">
                      <li
                        onClick={() => {
                          handleProfile();
                          setIsProfileOpen(false);
                        }}
                        className="py-1 px-2 d-flex align-items-center text-primary"
                      >
                        <i className="fas fa-user me-2"></i> Profile
                      </li>
                      {userRole === "admin" && (
                        <li
                          onClick={() => {
                            handleUpgradePlans();
                            setIsProfileOpen(false);
                          }}
                          className="py-1 px-2 d-flex align-items-center"
                        >
                          <i className="fas fa-arrow-up me-2 text-success"></i>
                          Upgrade Plan
                        </li>
                      )}

                      <li
                        onClick={() => {
                          handleLogout();
                          setIsProfileOpen(false);
                        }}
                        className="py-1 px-2 d-flex align-items-center text-danger"
                      >
                        <i className="fas fa-sign-out-alt me-2"></i> Logout
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </header>

          <div
            style={{
              pointerEvents: subscriptionStatus === "expired" ? "none" : "auto",
              opacity: subscriptionStatus === "expired" ? 0.5 : 1,
            }}
          >
            {renderStep(location.pathname)}
          </div>
        </div>
      </div>

      <Profile
        show={showProfileModal}
        handleClose={() => setShowProfileModal(false)}
        fetchUser={fetchUser}
      />
    </div>
  );
}

export default Dashboard;
